var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2083 4.58331C15.4957 4.58331 16.1394 4.58331 16.6019 4.89229C16.802 5.02604 16.9739 5.19792 17.1077 5.3981C17.4166 5.86051 17.4166 6.50422 17.4166 7.79165V16.5C17.4166 18.2285 17.4166 19.0927 16.8797 19.6297C16.3427 20.1666 15.4785 20.1666 13.75 20.1666H8.24998C6.5215 20.1666 5.65725 20.1666 5.12028 19.6297C4.58331 19.0927 4.58331 18.2285 4.58331 16.5V7.79165C4.58331 6.50422 4.58331 5.86051 4.89229 5.3981C5.02604 5.19792 5.19792 5.02604 5.3981 4.89229C5.86051 4.58331 6.50422 4.58331 7.79165 4.58331",
    stroke: "#E8A941",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 4.58333C8.25 3.57081 9.07081 2.75 10.0833 2.75H11.9167C12.9292 2.75 13.75 3.57081 13.75 4.58333C13.75 5.59586 12.9292 6.41667 11.9167 6.41667H10.0833C9.07081 6.41667 8.25 5.59586 8.25 4.58333Z",
    stroke: "#E8A941",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11L13.75 11",
    stroke: "#E8A941",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 14.6667L11.9167 14.6667",
    stroke: "#E8A941",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTodo);
export default __webpack_public_path__ + "static/media/icon-todo.38afce1ef95e2b05d2792bb866262161.svg";
export { ForwardRef as ReactComponent };